import type { ReactNode } from "react";
import cn from "~/utils/cn";

export type Tone = "success" | "warning" | "info" | "danger" | "neutral";
const tones: Record<Tone, string> = {
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  info: "bg-accent-soft text-accent-text",
  danger: "bg-danger-soft text-danger",
  neutral: "bg-bg-2 text-ink-2",
};

export default function Badge({ tone = "neutral", children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return <span className={cn("inline-flex h-6 shrink-0 items-center rounded-full px-2.5 text-xs font-medium", tones[tone], className)}>{children}</span>;
}
